import { Component, input } from '@angular/core';

@Component({
  selector: 'app-divider',
  imports: [],
  template: `
    <div [class]="dividerClasses" [attr.aria-orientation]="vertical() ? 'vertical' : 'horizontal'">
      @if (text() && !vertical()) {
        <span class="px-4 text-sm text-gray-500 dark:text-gray-400 bg-white dark:bg-gray-800">{{ text() }}</span>
      }
    </div>
  `,
  styles: []
})
export class DividerComponent {
  vertical = input<boolean>(false);
  text = input<string>('');
  spacing = input<'xs' | 'sm' | 'md' | 'lg' | 'xl'>('md');
  dashed = input<boolean>(false);

  get dividerClasses(): string {
    const classes = ['flex', 'items-center'];
    
    if (this.vertical()) {
      classes.push('w-px', 'h-full', 'bg-gray-200', 'dark:bg-gray-700');
      const spacingMap = { xs: 'mx-1', sm: 'mx-2', md: 'mx-3', lg: 'mx-4', xl: 'mx-6' };
      classes.push(spacingMap[this.spacing()]);
    } else {
      classes.push('w-full', 'h-px', 'bg-gray-200', 'dark:bg-gray-700');
      const spacingMap = { xs: 'my-1', sm: 'my-2', md: 'my-3', lg: 'my-4', xl: 'my-6' };
      classes.push(spacingMap[this.spacing()]);
    }

    if (this.dashed()) {
      classes.push('border-dashed');
    }

    return classes.join(' ');
  }
}

